import VideoPlayer from "components/VideoPlayer";
import { useBreakpoints } from "hooks/useBreakpoints";
import React from "react";
import { CodeShowcase } from "./CodeShowcase";
import { ProcessStepsSection } from "./ProcessStepsSection";

export const OverviewSection = () => {
  const { isMediumWidth, width } = useBreakpoints();

  return (
    <div className="relative">
      <div
        className="pointer-events-none absolute inset-0 flex flex-col"
        aria-hidden="true"
      >
        <div className="h-140 flex-none" />
        <div className="-z-10 w-full flex-1 bg-black" />
      </div>
      <div className="container-lg grid-gap grid grid-cols-12">
        <div className="relative col-span-full overflow-hidden rounded-lg md:col-span-8 md:col-start-3">
          <VideoPlayer />
        </div>
      </div>

      <div className="container-lg ">
        <div className="col-span-full mt-40  flex flex-col gap-32 text-center text-white md:mt-80 ">
          <div className="mx-auto max-w-2xl">
            <h2 className="text-18-28 opacity-70  md:text-32-40">
              No more waiting for manual annotation
            </h2>
            <h2 className="text-18-28 text-white md:text-32-40">
              Get started with programmatic labeling
            </h2>
          </div>
          <div className="mx-auto max-w-md text-14-20 text-gray-400 md:text-18-28 ">
            {/* Humanloop Programmatic is new kind of annoation tool. Instead of
            manual labelling, AI, rules and heuristics smartly label all your data
            enabling you to rapidly build groundbreaking NLP.  */}
            Humanloop Programmatic is a new kind of annotation tool that
            combines advances in weak supervision with data-centric UI to get
            you annotated data, fast.
          </div>
          <div className="col-span-full mb-40">
            <CodeShowcase size={isMediumWidth ? 24 : 18} />
          </div>
          <div className="">
            <ProcessStepsSection />
          </div>
        </div>
      </div>
    </div>
  );
};
